import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { X } from 'lucide-react'
import ModalTest from '../../BaseModal'
import {
  BottomDiv,
  Button,
  ButtonContainer,
  CloseDiv,
  ContainerOfModal,
  Header,
  HeaderTitle,
} from '../../styles/modal-style'
import axios from '../../../config/axios'
import { ParamType } from '../../../pages/ClientPanel/Certificates/CreateParam'
import {
  ColumnCell,
  ColumnHeader,
  ColumnsTable,
  EmptyState,
  FieldItem,
  FieldLabel,
  FieldsGrid,
  FieldValue,
  StructureCard,
  StructuresList,
  StructureTitle,
} from './style'

interface PropsType {
  paramId: number
  onClose: () => void
}

const displayValue = (value?: string | number | null) => {
  if (value === null || value === undefined || value === '') return '—'
  return String(value)
}

const ViewParamModal: React.FC<PropsType> = ({ paramId, onClose }) => {
  const navigate = useNavigate()
  const [param, setParam] = useState<ParamType | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    axios
      .get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/certificates/param/${paramId}`)
      .then(response => {
        if (response.data) setParam(response.data)
      })
      .catch(error => {
        console.error(error)
      })
      .finally(() => setLoading(false))
  }, [paramId])

  const fields: { label: string; value?: string }[] = [
    { label: 'Nome', value: param?.name },
    { label: 'Tipo', value: param?.type?.name },
    { label: 'Condição', value: param?.class },
    { label: 'Família', value: param?.family },
    { label: 'ASTM', value: param?.astm },
    { label: 'UNS', value: param?.uns },
    { label: 'DIN', value: param?.din },
    { label: 'AISI', value: param?.aisi },
    { label: 'Outras', value: param?.others },
  ]

  return (
    <ModalTest>
      <ContainerOfModal width="720px" maxHeight="85%">
        <Header>
          <HeaderTitle>Visualizar parâmetro</HeaderTitle>
          <CloseDiv onClick={onClose}>
            <X size={20} />
          </CloseDiv>
        </Header>

        {loading || !param ? (
          <EmptyState>Carregando parâmetro...</EmptyState>
        ) : (
          <>
            <FieldsGrid>
              {fields.map(field => (
                <FieldItem key={field.label}>
                  <FieldLabel>{field.label}</FieldLabel>
                  <FieldValue>{displayValue(field.value)}</FieldValue>
                </FieldItem>
              ))}
            </FieldsGrid>

            <StructuresList>
              {param.structures.length === 0 ? (
                <EmptyState>Nenhuma estrutura vinculada.</EmptyState>
              ) : (
                param.structures.map(structure => (
                  <StructureCard key={structure.id}>
                    <StructureTitle>{structure.name}</StructureTitle>
                    {structure.columns.length === 0 ? (
                      <EmptyState>Sem colunas nesta estrutura.</EmptyState>
                    ) : (
                      <ColumnsTable>
                        <ColumnHeader>Coluna</ColumnHeader>
                        <ColumnHeader>Mín</ColumnHeader>
                        <ColumnHeader>Máx</ColumnHeader>
                        {structure.columns.map(column => (
                          <React.Fragment key={column.id}>
                            <ColumnCell>{column.name}</ColumnCell>
                            <ColumnCell>{displayValue(column.min)}</ColumnCell>
                            <ColumnCell>{displayValue(column.max)}</ColumnCell>
                          </React.Fragment>
                        ))}
                      </ColumnsTable>
                    )}
                  </StructureCard>
                ))
              )}
            </StructuresList>
          </>
        )}

        <BottomDiv>
          <ButtonContainer>
            <Button onClick={onClose} className="cancel">
              Fechar
            </Button>
            <Button
              onClick={() => {
                onClose()
                navigate(`/panel/certificates/params/create?duplicateFrom=${paramId}`)
              }}
              className="cancel"
            >
              Duplicar
            </Button>
            <Button
              onClick={() => {
                onClose()
                navigate(`/panel/certificates/params/edit?id=${paramId}`)
              }}
            >
              Editar
            </Button>
          </ButtonContainer>
        </BottomDiv>
      </ContainerOfModal>
    </ModalTest>
  )
}

export default ViewParamModal
